import React, { useEffect, useRef } from "react"
import styles from "css/Toast.module.css"
import { Portal } from "components"
import { motion, AnimatePresence } from "framer-motion"

const Toast = ({ show, text, time = 3, setShow, children, customVariant, customClass }) => {

	//#region Variants
	const timer = useRef()
	const mounted = useRef(false)
	const variants = {
		hidden: {
			bottom: -70,
		},
		show: {
			bottom: 30,
		},
	}
	//#endregion

	//#region Methods
	const hideToast = () => {
		if (timer.current) clearTimeout(timer.current)
		setShow(false)
	}
	//#endregion

	//#region Effects
	useEffect(() => {
		if (show) {
			timer.current = setTimeout(() => {
				mounted.current && setShow && setShow(false)
			}, time * 1000)
		}
	}, [show, setShow, time])

	useEffect(() => {
		mounted.current = true

		return () => {
			mounted.current = false
		}
	}, [])
	//#endregion

	return (
		<Portal to="modal">
			<AnimatePresence>
				{show && (
					<motion.div onClick={hideToast} variants={customVariant??variants} initial="hidden" animate="show" exit="hidden" className={customClass ??styles.Toast}>
						{text}
						{children}
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	)
}

export default Toast
